import { useTranslation } from 'react-i18next';

import { Heading } from '@app/shared/ui/atoms/Common';
import { cn } from '@app/shared/utils/common';
import { pandaFaceImage } from '@app/assets';

interface NotFoundProps {
  message?: string;
  displayPanda?: boolean;
  withLightBlueBg?: boolean;
  containerClassName?: string;
}

export function NotFound({
  message,
  displayPanda = true,
  withLightBlueBg = false,
  containerClassName = '',
}: NotFoundProps) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'flex h-full w-full flex-col items-center justify-center gap-2 px-3 py-10',
        withLightBlueBg && 'rounded-xl bg-secondary/80',
        containerClassName
      )}
    >
      <Heading level={3} className="whitespace-pre-line text-center">
        {message || t('errors.no_results')}
      </Heading>
      {displayPanda && <img src={pandaFaceImage} alt="not found" className="w-[153px]" />}
    </div>
  );
}
